import { render, staticRenderFns } from "./SettsDelAcc.vue?vue&type=template&id=5c248cda"
import script from "./SettsDelAcc.vue?vue&type=script&lang=js"
export * from "./SettsDelAcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports